export enum GtmEvent {
    FIRE_PAGE_VIEW = 'gtmFirePageView'
}
